import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/permission'
import './icons'
import './styles/index.less'
// import '@/utils/disableViewCode'
import directive from '@/directive/index'
import 'amfe-flexible' // 引入自适应布局库

// 设置 rem 基准值（根据设计稿动态计算）
// function setRemUnit() {
//   const screenWidth = document.documentElement.clientWidth
//   if (screenWidth <= 768) {
//     // 移动端：375px 设计稿基准
//     document.documentElement.style.fontSize = screenWidth / 7.5 + 'px'
//   } else {
//     // PC端：1440px 设计稿基准
//     document.documentElement.style.fontSize = Math.min(screenWidth, 1440) / 14.4 + 'px'
//   }
// }

// setRemUnit()
// window.addEventListener('resize', setRemUnit)

// 动态设置根字体大小（实现响应式）
// function setRem() {
//   const baseSize = 144 // 与 rootValue 一致
//   const minWidth = 320
//   const screenWidth = Math.max(window.innerWidth, minWidth)
//   // const scale = document.documentElement.clientWidth / 1440 // 基于设计稿比例
//   const scale = screenWidth / 1440 // 基于设计稿比例
//   document.documentElement.style.fontSize = baseSize * Math.min(scale, 1.5) + 'px' // 限制最大缩放
// }

// setRem()
// window.addEventListener('resize', setRem)

Vue.use(ElementUI, {
  size: 'medium'
});
Vue.use(directive)

Vue.config.productionTip = false;
Vue.prototype.$cdn = 'https://shouyin-oss.oss-cn-hangzhou.aliyuncs.com/assets/';

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
